/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Open_UsersInputs */

const cs_ebr_open_users = /** @type {(inputs: Ebr_Open_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít uživatele`)
};

const en_ebr_open_users = /** @type {(inputs: Ebr_Open_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open users`)
};

/**
* | output |
* | --- |
* | "Open users" |
*
* @param {Ebr_Open_UsersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_open_users = /** @type {((inputs?: Ebr_Open_UsersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Open_UsersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_open_users(inputs)
	return cs_ebr_open_users(inputs)
});